'use client'

import LoginRewardView from 'member/components/Pc/Login/LoginView/LoginReward/LoginRewardView/LoginRewardView'

const LoginReward = () => <LoginRewardView />

export default LoginReward
